import { render, staticRenderFns } from "./BuyerCreateCampaign.vue?vue&type=template&id=58352fdc&scoped=true"
import script from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerCreateCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58352fdc",
  null
  
)

export default component.exports